/**
 * Sentry Browser
 */

//#region Imports
import {
  captureEvent,
  captureException,
  captureMessage,
  init,
  setExtra,
  setTag,
  setUser,
  withScope,
  addBreadcrumb,
  lastEventId,
} from "@sentry/browser";
import { ISentryAdapter } from "./ISentryAdapter";
//#endregion

export const SentryAdapter: ISentryAdapter = {
  captureEvent,
  captureException,
  captureMessage,
  lastEventId,
  init,
  setExtra,
  setTag,
  setUser,
  withScope,
  addBreadcrumb,
};
